import { Button, Input } from 'reactstrap'
import { PREDEFINED_ACTORS } from '../data/predefined-actors'
import { useAppDispatch } from '../redux/redux-hooks'
import { ViewTimelineActions } from '../redux/slices/view-timeline-slice'
import { assertInvariant } from '../util/utils'

export const SubHeader = (): JSX.Element | null => {

    const appDisp = useAppDispatch()

    return (
        <div className="space-mx-2 d-flex align-items-end">

            <Input
                bsSize="sm"
                type="select"
                className="flex-grow-1"
                onChange={(ev) => {

                    const specValue = ev.target.value

                    if (specValue === "") {
                        return
                    }

                    const selectedSpec = PREDEFINED_ACTORS.flatMap(actor => {
                        const maybeSpec = actor.specs.find(s => s.value === specValue)

                        if (maybeSpec) {
                            return [{ color: actor.color, spec: maybeSpec }]
                        } else {
                            return []
                        }
                    })

                    assertInvariant(selectedSpec.length === 1, `Expected to find exactly one match`)

                    appDisp(ViewTimelineActions.createActorFull({
                        color: selectedSpec[0].color,
                        predefinedSpec: selectedSpec[0].spec
                    }))

                }}
                value={""}
            >
                <option key={"1"} value={""}>
                    {"-- Add predefined actor --"}
                </option>

                {PREDEFINED_ACTORS.map(actor => {
                    return (
                        <optgroup key={actor.label} label={actor.label}>
                            {actor.specs.map((spec) => {
                                return (
                                    <option key={spec.value} value={spec.value}>
                                        {spec.label}
                                    </option>
                                )
                            })}
                        </optgroup>
                    )
                })}
            </Input>

            <Button className="flex-shrink-0" size="sm" onClick={() => {
                appDisp(ViewTimelineActions.createActor({ name: 'Untitled' }))
            }}>
                {"Add custom actor"}
            </Button>

        </div >
    )
}